import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { HasPrivilegeModule } from 'src/app/@core/directives/has-privilege/has-privilege.module';
import { BiometryService } from 'src/app/services/biometry.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CustomersModule } from '../customers/customers.module';
import { AuthTokenGenerationModule } from './auth-token-generation/auth-token-generation.module';
import { BiometryCreateModule } from './biometry-create/biometry-create.module';
import { BiometryRoutingModule } from './biometry-routing.module';
import { BiometryComponent } from './biometry.component';
import { BiometryFingerPrintModule } from './biometryFingerPrint/biometryFingerPrint.module';



@NgModule({
  declarations: [BiometryComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BiometryRoutingModule,
    TabsModule,
    CustomersModule,
    BiometryFingerPrintModule,
    AuthTokenGenerationModule,
    HasPrivilegeModule,
    BiometryCreateModule,
  ],
  providers: [DatePipe, BiometryService, ConfigurationService],
  exports: [BiometryComponent]
})
export class BiometryModule { }
